import { render, staticRenderFns } from "./group_translate.vue?vue&type=template&id=d51e137c&scoped=true&"
import script from "./group_translate.vue?vue&type=script&lang=js&"
export * from "./group_translate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51e137c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d51e137c')) {
      api.createRecord('d51e137c', component.options)
    } else {
      api.reload('d51e137c', component.options)
    }
    module.hot.accept("./group_translate.vue?vue&type=template&id=d51e137c&scoped=true&", function () {
      api.rerender('d51e137c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/tabs/group_translate.vue"
export default component.exports